import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
import { createApp, reactive } from 'petite-vue';
import { Liquid } from 'liquidjs';
import LiquidRenderer from "./liquid-renderer";

export {
    Swiper,
    Navigation,
    Pagination,
    Autoplay,
    EffectFade,
    Liquid,
    LiquidRenderer,
    createApp,
    reactive
}
